/**
 * Smooth Scroll Component
 */
(function () {
  "use strict";

  const SmoothScroll = {
    init() {
      // Handle anchor links with smooth scroll
      document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
        anchor.addEventListener("click", (e) => {
          const href = anchor.getAttribute("href");
          if (href && href !== "#") {
            const target = document.querySelector(href);
            if (target) {
              e.preventDefault();
              const header = document.querySelector("[data-header]");
              const headerHeight = header ? header.offsetHeight : 0;
              const offset =
                href.includes("shop") || href.includes("faq")
                  ? headerHeight + 12
                  : 0;
              const y =
                target.getBoundingClientRect().top + window.scrollY - offset;
              window.scrollTo({ top: y, behavior: "smooth" });
            }
          }
        });
      });

      // Handle scroll to section buttons
      document.querySelectorAll("[data-scroll-to]").forEach((button) => {
        button.addEventListener("click", (e) => {
          const targetId = button.dataset.scrollTo;
          const target = document.getElementById(targetId);
          if (target) {
            e.preventDefault();
            const header = document.querySelector("[data-header]");
            const headerHeight = header ? header.offsetHeight : 0;
            const targetTop =
              target.getBoundingClientRect().top + window.scrollY;
            const currentScrollY = window.scrollY;

            // Only apply offset when scrolling up (current position is below target)
            const isScrollingUp = currentScrollY > targetTop;
            const offset = isScrollingUp ? headerHeight + 12 : 0;
            const y = targetTop - offset;

            window.scrollTo({ top: y, behavior: "smooth" });
          }
          // If target isn't on this page, do nothing here and let the link's
          // href navigate normally (e.g. /#shop loads the homepage and scrolls).
        });
      });
    },
  };

  window.SmoothScroll = SmoothScroll;
})();